export default __webpack_public_path__ + "static/faq-mobile-up-144a0ae8dfad180b9232702daf4a361e.jpg";